import styled from "styled-components";

// Colors
import { colors } from "colors/index";

export const Main = styled.main`
    margin-top: 5rem;
    background-color: ${colors.primary};
    height: 100%;
`